import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance";

// //Update Leave Type
// export const updateLeaveType = async (id: number, body: any) => {
//   console.log(`id--------->${id}-------->body:${JSON.stringify(body)}`);
//   return axiosInstance.put(
//     `${API_ENDPOINTS.LEAVE.UPDATE_LEAVE_TYPE}/${id}`,
//     body
//   );
// };

// Get Grand Masters
export const getGradeMastersData = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EMPLOYEE.GET_GRADE_MASTERS
  );

  console.log(
    "🚀 ~ GradeMasterRepository.tsx:38 ~ getGradeMastersData ~ response:",
    response
  );

  return response?.data;
};

// Get Budgets
export const getBudgetsData = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.CONFIGURATION.GET_BUDGETS,
    params
  );

  console.log(
    "🚀 ~ GradeMasterRepository.tsx:53 ~ getBudgetsData ~ response:",
    response
  );
  return response?.data;
};

// Add Grade Master
export const addGradeMaster = async (body: any) => {
  return axiosInstance.post(API_ENDPOINTS.CONFIGURATION.ADD_GRADE_MASTER, body);
};

//Update Grade Master
export const updateGradeMaster = async (/* id: number, */ body: any) => {
  console.log(`-------->body:${JSON.stringify(body)}`);
  return axiosInstance.put(API_ENDPOINTS.CONFIGURATION.EDIT_GRADE_MASTER, body);
};

// Add Policy Master
export const getPolicyMasterData = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.CONFIGURATION.GET_POLICY_MASTER,
    params
  );

  console.log(
    "🚀 ~ GradeMasterRepository.tsx:60 ~ getPolicyMasterData ~ response:",
    response
  );

  return response?.data;
};

// Add Policy Master
export const getOrgUnitsData = async () => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.EMPLOYEE.GET_ORG_UNITS
  );

  console.log(
    "🚀 ~ GradeMasterRepository.tsx:75 ~ getOrgUnitsData ~ response:",
    response
  );

  return response?.data;
};

// Add Policy Master
export const getGradePolicyData = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.CONFIGURATION.GET_GRADE_POLICY,
    { params: params }
  );

  console.log(
    "🚀 ~ GradeMasterRepository.tsx:90 ~ getGradePolicyData ~ response:",
    response
  );

  return response?.data;
};

// Get Currencies
export const getCurrencies = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.CONFIGURATION.GET_CURRENCIES,
    params
  );

  console.log(
    "🚀 ~ GradeMasterRepository.tsx:104 ~ getCurrencies ~ response:",
    response
  );

  return response?.data;
};

// Add Policy Master
export const addPolicyMaster = async (body: any) => {
  return axiosInstance.post(
    API_ENDPOINTS.CONFIGURATION.ADD_POLICY_MASTER,
    body
  );
};

//Update Policy Master

export const updatePolicyMaster = async (/* id: number, */ body: any) => {
  console.log(`-------->body:${JSON.stringify(body)}`);
  return axiosInstance.put(
    API_ENDPOINTS.CONFIGURATION.UPDATE_POLICY_MASTER,
    body
  );
};

// Add Grade Policy
export const addGradePolicy = async (body: any) => {
  return axiosInstance.post(API_ENDPOINTS.CONFIGURATION.ADD_GRADE_POLICY, body);
};

// Update Grade Policy
//UPDATE_GRADE_POLICY

export const updateGradePolicy = async (/* id: number, */ body: any) => {
  console.log(`-------->body:${JSON.stringify(body)}`);
  return axiosInstance.put(
    API_ENDPOINTS.CONFIGURATION.UPDATE_GRADE_POLICY,
    body
  );
};

//DELETE_GRADE_POLICY

export const deleteGradePolicy = async (params: Record<string, any>) => {
  // return axiosInstance.delete(
  //   `${API_ENDPOINTS.CONFIGURATION.DELETE_GRADE_POLICY}/${id}`,
  // );

  const response = await axiosInstance.delete(
    API_ENDPOINTS.CONFIGURATION.DELETE_GRADE_POLICY,
    { params: params }
  );

  console.log(
    "🚀 ~ GradeMasterRepository.tsx:158 ~ deleteGradePolicy ~ response:",
    response
  );

  return response?.data;
};
